<template>
<div> 
  <div class="columns">
    <div class="column">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Checkpoint</th>
            <th>CWE</th>
            <th class="is-narrow">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="checkpoint in checkpoints" :key="checkpoint.id">
            <td>
              <router-link
                :to="{
                  name: 'checkpoint-manager',
                  params: {
                    checkpoint: checkpoint.id
                  }
                }">
                {{ checkpoint.value }}
              </router-link>
            </td>
            <td>{{ checkpoint.cwe.number }}</td>
            <td class="has-text-right">
              <action-button @click="removeCheckpoint(checkpoint)" class="is-danger is-small is-rounded">
                <icon icon="trash"/>
              </action-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>  
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { searchAndAddCheckpoint } from '@/modals'
import { addCheckpoint, loadSectionCheckpoints, removeCheckpoint } from '@/api/super'
export default {

  data: () => ({
    checkpoints: [],
  }),

  created() {
    loadSectionCheckpoints(this.$route.params.section, ({data}) => {
      this.checkpoints = data
    }, error => {})
  },

  methods: {
    async openSearch() {
      if(await searchAndAddCheckpoint(this.section)) {
        loadSectionCheckpoints(this.section.id, ({data}) => {
          this.checkpoints = data
        }, error => {})
      }
    },
    async removeCheckpoint(checkpoint) {
      if(await this.$confirm({
        title: 'Remove checkpoint',
        message: 'Are you sure you want to remove this checkpoint?'
      })) {
        removeCheckpoint({
            sectionId: this.$route.params.section,
            checkpointId: checkpoint.id,
          }, () => {
            let index = this.checkpoints.indexOf(checkpoint)
            this.checkpoints.splice(index, 1)
          }, error => {

          })
      }
    }
  },

  computed: {
    ...mapGetters('standardSection', [
      'section'
    ])
  }
}
</script>